export const filtrarInsumosFisicos = (insumos) =>
  (insumos || []).filter(
    (ins) => !ins.servicio && !ins.libroVirtual && !ins.dropshipping,
  );

// Estado visual (0-5) derivado por insumo, a partir de datos de la venta
export const estadoVisualInsumo = (insumo, envio) => {
  const entregado = insumo.entregado || 0;
  if (insumo.cantidad > 0 && entregado >= insumo.cantidad) return 5;
  if (envio.estadoPaquete < 2) return envio.estadoPaquete;
  if (!insumo.empaquetado) return 1;
  return 2;
};

export const agruparInsumosPorEstadoVisual = (venta, envio) => {
  const insumosFisicos = filtrarInsumosFisicos(venta.insumos);
  const grupos = new Map();
  insumosFisicos.forEach((ins) => {
    const estado = estadoVisualInsumo(ins, envio);
    if (!grupos.has(estado)) grupos.set(estado, []);
    grupos.get(estado).push(ins);
  });
  return grupos;
};
